"use strict";

var getHeight = function getHeight(element) {
  element.style.display = 'block';
  var height = element.scrollHeight;
  element.style.display = '';
  return height;
};

var accordion = document.querySelectorAll('.accordion');

var _loop = function _loop(i) {
  var headers = makeArray(accordion[i].querySelectorAll('.accordion__header'));
  var content = makeArray(accordion[i].querySelectorAll('.accordion__content'));
  headers.forEach(function (header, index) {
    header.addEventListener('click', function () {
      var accordionWrapper = header.parentElement;
      var contentHeight = getHeight(content[index]);

      if (accordionWrapper.className.indexOf('is-open') > -1) {
        accordionWrapper.classList.remove('is-open');
        content[index].style.height = '0px';
      } else {
        accordionWrapper.classList.add('is-open');
        content[index].style.height = "".concat(contentHeight, "px");
      }
    });
  });
};

for (var i = 0; i < accordion.length; i += 1) {
  _loop(i);
}